"use client";

import type { TaskListColor } from "@orsane/schema/task-lists";
import { taskListColorValues } from "@orsane/schema/task-lists";
import * as React from "react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import { TaskListBadgeColorShape } from "./TaskListBadge";

function SelectorButton({ selected, children, ...props }: { selected: boolean; children: React.ReactNode; [key: string]: any }) {
    return (
        <Button
            variant="ghost"
            size="icon"
            className={cn(["size-8"], {
                "bg-neutral-100 border border-neutral-200 pointer-events-none": selected,
            })}
            {...props}
        >
            {children}
        </Button>
    );
}

export default function ColorSelector({
    color,
    onApply,
    buttonClassName,
    disabled,
}: {
    color: TaskListColor;
    onApply: (color: TaskListColor) => void;
    buttonClassName?: string;
    disabled?: boolean;
}) {
    const [open, setOpen] = React.useState(false);
    const [selectedColor, setSelectedColor] = React.useState<TaskListColor>(color as TaskListColor);

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger
                render={
                    <Button variant="ghost" size="icon" className={buttonClassName} tabIndex={-1} disabled={disabled}>
                        <TaskListBadgeColorShape color={selectedColor} />
                    </Button>
                }
            />
            <PopoverContent className="w-auto">
                <div className="grid grid-cols-6 gap-1">
                    {taskListColorValues.map((color) => (
                        <SelectorButton
                            key={color}
                            selected={selectedColor === color}
                            title={color}
                            onClick={() => {
                                setOpen(false);
                                setSelectedColor(color);
                                onApply(color);
                            }}
                        >
                            <TaskListBadgeColorShape color={color} />
                        </SelectorButton>
                    ))}
                </div>
            </PopoverContent>
        </Popover>
    );
}
